import type { FC } from 'react';

import type { Gem } from '../../../../../gameInfo/results/treasureIsland/types';
import { GemCode } from '../../../../../gameInfo/results/treasureIsland/types';
import EmeraldIcon from '../../assets/collector-panel/Emerald.png';
import RubyIcon from '../../assets/collector-panel/Ruby.png';
import TopazIcon from '../../assets/collector-panel/Topaz.png';

import styles from './GemsList.module.css';

const GEM_ICONS: Record<string, string> = {
  Topaz: TopazIcon,
  Emerald: EmeraldIcon,
  Ruby: RubyIcon,
};

export interface SingleGemProps {
  icon: string;
  multiplier: number | string;
}

interface GemsListProps {
  gemsData: Gem[];
}

const prepareGemData = <T extends Gem | undefined>(data: T | T[]): Record<string, string> => {
  const dataArray = Array.isArray(data) ? data : data ? [data] : [];
  return dataArray.reduce((prev, current) => {
    if (!current) return prev;
    const { key, val } = current;
    return { ...prev, [key]: val };
  }, {});
};

export const getGems = <T extends Record<string, string>>(gems: T): SingleGemProps[] => {
  return [
    {
      icon: GemCode[GemCode.Topaz],
      multiplier: GemCode.Topaz in gems ? gems[GemCode.Topaz] : '',
    },
    {
      icon: GemCode[GemCode.Emerald],
      multiplier: GemCode.Emerald in gems ? gems[GemCode.Emerald] : '',
    },
    {
      icon: GemCode[GemCode.Ruby],
      multiplier: GemCode.Ruby in gems ? gems[GemCode.Ruby] : '',
    },
  ];
};

export const SingleGem: FC<SingleGemProps> = ({ icon, multiplier }) => {
  return (
    <div className={styles.gem}>
      <img src={GEM_ICONS[icon]} alt={icon} />
      <span>{multiplier}</span>
    </div>
  );
};

export const GemsList: FC<GemsListProps> = ({ gemsData }) => {
  const parsedData = prepareGemData(gemsData);
  const gems = getGems(parsedData);
  return gems.map((gem, index) => <SingleGem key={`gem_${index}`} {...gem} />);
};
